/* eslint key-spacing: 0 */
/* eslint comma-spacing: 0 */
/* global SceneCollection */
/* global Scene */

// The main collection of scene data

var sceneCollection = new SceneCollection();

// Add the defined scenes

sceneCollection.addScene(

	new Scene(
		"HOVED- INDGANG",
		true,
		"textures/skanska_cph_highline_r2_view06_exterior_entrance_left.jpg",
		"textures/skanska_cph_highline_r2_view06_exterior_entrance_left.jpg",
		"Cph Highline hovedindgang",
		"Velkommen til Cph Highline. Et kontor med kant, charme og sjæl.\nTæt på city og lige ved vandet.",
		"images/skanska_cph_highline_r2_view06_exterior_entrance_preview.png",
		null,
		0.17809068130930802,
		0.6758620689655173,
		"images/skanska_cph_highline_r2_view06_exterior_entrance_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-479.04404780957054,"y":12.387539091586001,"z":139.5094845123618},"scale":50,"distPercentage":0.75,"linkedSceneName":"indgang/ foyer"}]},
		7.2,
		166.6
	)
);

sceneCollection.addScene(

	new Scene(
		"INDGANG/ FOYER",
		true,
		"textures/skanska_cph_highline_entrance_lobby_left.jpg",
		"textures/skanska_cph_highline_entrance_lobby_right.jpg",
		"Indgang og foyer",
		"Du og dine gæster bliver budt velkommen i et lyst, åbent og venligt receptionsmiljø,\nder også fungerer som lounge- og opholdsområde.",
		"images/skanska_cph_highline_entrance_lobby_preview.png",
		null,
		0.24723258392073028,
		0.6477732793522267,
		"images/skanska_cph_highline_entrance_lobby_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-411.9496275103309,"y":-23.71316718105125,"z":280.72597197860944},"scale":50,"distPercentage":0.75,"linkedSceneName":"foyer/ atrium"}]},
		-1.8,
		-77.8
	)
);


sceneCollection.addScene(

	new Scene(
		"FOYER/ ATRIUM",
		true,
		"textures/skanska_cph_highline_lobby_second_floor_left.jpg",
		"textures/skanska_cph_highline_lobby_second_floor_right.jpg",
		"Foyer/atrium",
		"Fra de fleksible arbejdsstationer på 1. sal kan du lade dig inspirere af\net panorama view mod atrium-området og det grønne gårdrum.",
		"images/skanska_cph_highline_lobby_second_floor_preview.png",
		null,
		0.19974383167685664,
		0.6253807106598985,
		"images/skanska_cph_highline_lobby_second_floor_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-463.80307548127917,"y":-16.083186812315972,"z":-183.29276915557},"scale":50,"distPercentage":0.75,"linkedSceneName":"kontor"}]},
		-9.5,
		-147.5
	)
);

/*sceneCollection.addScene(

	new Scene(
		"RECEPTION",
		true,
		"textures/skanska_cph_highline_r2_view04_interior_lobby_left.jpg",
		"textures/skanska_cph_highline_r2_view04_interior_lobby_right.jpg",
		"Reception",
		"Receptionen med loungeområdet er hjertet i huset.\nHer har du højt til loftet og kan nyde\net panorama view mod det grønne gårdrum.",
		"images/skanska_cph_highline_r2_view04_interior_lobby_preview.png",
		null,
		0.24723258392073028,
		0.6477732793522267,
		"images/skanska_cph_highline_r2_view04_interior_lobby_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-88.89077620292345,"y":8.53348952346643,"z":491.1208717548387},"scale":50,"distPercentage":0.75,"linkedSceneName":"kontor"}]},
		-1.8,
		-77.8
	)
);*/

sceneCollection.addScene(

	new Scene(
		"KONTOR",
		false,
		"textures/skanska_cph_highline_r2_view03_interior_vip_meeting_left.jpg",
		"textures/skanska_cph_highline_r2_view03_interior_vip_meeting_right.jpg",
		"Kontor med udsigt",
		"Dobbelthøjt rum med udsigt ud over København.\nRummet kan bruges til f.eks. åben arbejdszone og møderum.",
		"images/skanska_cph_highline_r2_view03_interior_vip_meeting_preview.png",
		null,
		0.1970414163282561,
		0.5161579892280072,
		"images/skanska_cph_highline_r2_view03_interior_vip_meeting_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":327.92030355228906,"y":-24.443825667468683,"z":-375.7193061144608},"scale":50,"distPercentage":0.75,"linkedSceneName":"taghave"}]},
		-5.4,
		271.9
	)
);

sceneCollection.addScene(

	new Scene(
		"TAGHAVE",
		false,
		"textures/skanska_cph_highline_r2_view02_exterior_urban_farming_left.jpg",
		"textures/skanska_cph_highline_r2_view02_exterior_urban_farming_right.jpg",
		"Taghave med café, arbejdszone og\nUrban Gardening",
		"Café, bar og event område. Her kan du holde møder, arrangementer og netværke for åben himmel. Plantekasserne leverer grønt til kantinen og skaber et anderledes miljø.",
		"images/skanska_cph_highline_r2_view02_exterior_urban_farming_preview.png",
		null,
		0.35267515383059855,
		0.5404858299595142,
		"images/skanska_cph_highline_r2_view02_exterior_urban_farming_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":308.09844636191065,"y":7.096141416141139,"z":-392.6465874522701},"scale":50,"distPercentage":0.75,"linkedSceneName":"café"}]},
		-5.1,
		407.4
	)
);

sceneCollection.addScene(

	new Scene(
		"CAFÉ",
		false,
		"textures/skanska_cph_highline_r2_view01_exterior_cafe_left.jpg",
		"textures/skanska_cph_highline_r2_view01_exterior_cafe_right.jpg",
		"Café med udsigt over havnen",
		"Caféområde med udsigt over havneløbet og det maritime miljø\nomkring husbådhavnen. Tag et møde eller en kaffepause i solen.",
		"images/skanska_cph_highline_r2_view01_exterior_cafe_preview.png",
		null,
		0.6112261129246591,
		0.7560728744939271,
		"images/skanska_cph_highline_r2_view01_exterior_cafe_overview_thumbnail.png",
		{"dataset":[{"intersectionPoint":{"x":-492.88547099736707,"y":-34.40212904037095,"z":71.26131433016243},"scale":50,"distPercentage":0.75,"linkedSceneName":"hoved- indgang"}]},
		-0.8,
		179.9
	)
);
